import { setAuthAccount } from "./set-auth-account";
import { setUpdateCredentials } from "./set-update-credentials";

export class ExpertAuthService {
  constructor () {
    this.setAuthAccount = setAuthAccount;
    this.setUpdateCredentials = setUpdateCredentials;
  }
}
